module.exports = __webpack_public_path__ + "img/zhangjinyang.c51ba646.jpg";